import { render, staticRenderFns } from "./applyList.vue?vue&type=template&id=8ffba5fa&scoped=true"
import script from "./applyList.vue?vue&type=script&lang=js"
export * from "./applyList.vue?vue&type=script&lang=js"
import style0 from "./applyList.vue?vue&type=style&index=0&id=8ffba5fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffba5fa",
  null
  
)

export default component.exports